import React, { type JSX } from 'react'
import classNames from 'classnames'
import SvgClose from '../../svg/close.svg'
import { IconProps } from '../icon-props'

const CloseIcon = ({
  className = '',
  multiLayered = false,
  ...props
}: IconProps): JSX.Element | null => (
  <SvgClose
    {...props}
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    className={classNames('i-close', className, {
      'i-multi-layered': multiLayered,
    })}
  />
)

export default CloseIcon
